import React, {useCallback, useEffect, useRef, useState} from "react";
import chevronLeft from "../../assets/feather/chevron-left.svg";
import chevronRight from "../../assets/feather/chevron-right.svg";

export function useHorizontalScroller() {
    const ref = useRef<HTMLDivElement | null>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const sync = useCallback(() => {
        const el = ref.current;
        if (!el) {
            return;
        }

        const maxScroll = el.scrollWidth - el.clientWidth;
        setCanScrollLeft(el.scrollLeft > 1);
        setCanScrollRight(el.scrollLeft < maxScroll - 1);
    }, []);

    useEffect(() => {
        const el = ref.current;
        if (!el) {
            if (process.env.NODE_ENV !== "production") {
                console.warn("[useHorizontalScroller] ref hiçbir öğeye bağlanmamış - " +
                    "kaydırılan elemana `ref={scroller.ref}` eklemeyi unutmayın; oklar çizilmez.");
            }
            return;
        }
        sync();
        el.addEventListener("scroll", sync, {passive: true});
        window.addEventListener("resize", sync);

        const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(sync) : null;
        observer?.observe(el);
        return () => {
            el.removeEventListener("scroll", sync);
            window.removeEventListener("resize", sync);
            observer?.disconnect();
        };
    }, [sync]);

    const scrollByDirection = useCallback((direction: -1 | 1) => {
        const el = ref.current;
        if (!el) {
            return;
        }

        el.scrollBy({left: direction * Math.max(el.clientWidth * 0.8, 160), behavior: "smooth"});
    }, []);

    return {ref, canScrollLeft, canScrollRight, scrollByDirection, sync};
}

export function ScrollArrows({scroller, className}: { scroller: ReturnType<typeof useHorizontalScroller>; className?: string }) {
    const {canScrollLeft, canScrollRight, scrollByDirection} = scroller;

    if (!canScrollLeft && !canScrollRight) {
        return null;
    }

    return (
        <>

                <button type="button"
                        aria-label="Sola kaydır"
                        className={`scroll-arrow scroll-arrow-left ${className ?? ""}`}
                        onClick={() => scrollByDirection(-1)}>
                    <img src={chevronLeft} alt="" width={20} height={20}/>
                </button>

                <button type="button"
                        aria-label="Sağa kaydır"
                        className={`scroll-arrow scroll-arrow-right ${className ?? ""}`}
                        onClick={() => scrollByDirection(1)}>
                    <img src={chevronRight} alt="" width={20} height={20}/>
                </button>
        </>
    );
}
